import logger from "flow/logger";
import { Dictionary } from "flow/api/types";
//import ClientLogLevel from "flow/entities/ClientLogLevel";
import { getString, getBool, getNumber, getUrl } from "flow/manifests/metaParserHelper";
import environment from "flow/configuration/environment";
import config from "flow/config";

export default class WebModuleEntry {
    id: string;
    isActive: boolean;
    logLevel: number;
    moduleKeyName: string;
    name: string;
    runtimeContext: string;
    url: string;
    products: string[];
    isEmpty: boolean;
    isBroken: boolean;
    onDemandOnly: boolean;
    dependent: string;

    constructor(entryName: string, entryData: Dictionary) {
        this.id = getString("Id", entryData, undefined);
        this.isActive = getBool("IsActive", entryData, false);
        this.logLevel = getNumber("LogLevel", entryData, -1); // ClientLogLevel.None

        this.moduleKeyName = entryName;
        this.name = getString("Name", entryData, undefined);
        this.runtimeContext = getString("VisibleInRuntimeContext", entryData, undefined);
        this.url = getUrl("Url", entryData);

        if (environment.get(environment.keys.useProductSelector)) {
            this.products = getString("Products", entryData, config.otherProductId)
                .split(",")
                .map(s => s.trim());
        } else {
            this.products = [config.otherProductId];
        }

        this.isEmpty = false;
        this.isBroken = false;
        this.onDemandOnly = getBool("OnDemandOnly", entryData, false);
        this.dependent = getString("Dependent", entryData, undefined);

        this.validate();
    }

    validate = () => {
        if (!this.url) {
            throw new Error(
                this.moduleKeyName + " is missing a url in the configuration. Will not be used until it is fixed."
            );
        }

        if (!this.id) {
            throw new Error(
                this.moduleKeyName + " is missing an id in the configuration. Will not be used until it is fixed."
            );
        }

        if (!this.name) {
            logger.log(this.moduleKeyName + " is missing a name in the configuration. Will default to id.");
            this.name = this.id;
        }
    };
}
